import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {SafeResourceUrl} from "@angular/platform-browser";
import {
  AnagraficaUtentePortalePagineCompilate,
} from "../../models/anagrafica.models";
import {BasePageComponent} from "../../base-page.component";
import {AuthService} from "../../services/auth.service";
import {RegistryService} from "../../services/domain/registry.service";
import {ConfirmationService} from "primeng/api";
import {JobPostService} from "../../services/domain/jobpost.service";
import {StudyService} from "../../services/domain/study.service";
import {DocumentService} from "../../services/domain/document.service";

@Component({
  selector: 'app-header-dashboard',
  templateUrl: './header-dashboard.component.html',
  styleUrls: ['./header-dashboard.component.css'],
  providers : [RegistryService, ConfirmationService, JobPostService, StudyService, DocumentService]
})
export class HeaderDashboardComponent extends BasePageComponent implements OnInit{

  @Input() isDisabled: boolean = false;
  constructor(private registryService : RegistryService,
              private confirmationService : ConfirmationService,
              private documentService : DocumentService) {
    super();

  }
  @Input() showBtnRedirect: boolean = true;
  @ViewChild('profilePhoto') profilePhotoFile : any;
  public profileImageUrl : SafeResourceUrl | null = null;
  public profileName : string  = "";
  public registryCompletedPages : AnagraficaUtentePortalePagineCompilate = new AnagraficaUtentePortalePagineCompilate();
  public percCompleted : number = 0;
  public showValueBar : boolean = true;
  public baseImagePath : string = "";
  public customAvatarSize : string = "";
  public radius: number = 0;



  ngOnInit(): void {
    this.customAvatarSize = '50%';
    this.getCompletedPages();
    this.authService.getUserPhoto().then((value) => {
      this.profileImageUrl = value;
    });
    if (AuthService.LoggedUser)
      this.profileName = AuthService.LoggedUser.name ?? "";

    this.baseImagePath = this.authService.baseImagePath;
    window.addEventListener('resize', () => {
      this.setRadius(); // Aggiorna il valore di radius quando cambia la larghezza dello schermo
    });
  }

  public updateProfileImageClick(){
    this.profilePhotoFile.nativeElement.click();
  }

  public updateProfilePhoto(event : any){
    this.confirmationService.confirm({
      message: "Vuoi cambiare l' immagine del profilo?",
      header: 'Richiesta conferma',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const fileProfileToUpload = event.files[0]
        const maxSizeFile = 4194304;
        if(fileProfileToUpload != null && fileProfileToUpload.size < maxSizeFile)
          this.updateProfilePhotoApi(fileProfileToUpload);
        else
          return this.showError("Caricare una immagine di max 4mb");
      }
    });
  }

  private updateProfilePhotoApi(file: File){
    this.asyncCall(() => {
      let formData = new FormData();
      formData.append("file", file, file.name);
      return this.documentService.updateProfileImage(AuthService.LoggedUser?.profileId ?? 0,formData);
    }, () => {
      this.showMessageSaveCompleted();
      this.authService.getUserPhoto().then((value) => {
        this.profileImageUrl = value;
        this.authService.changeUserPhoto.next(null);
      });
    });
  }

  public setRadius(){
    this.radius = window.innerWidth < 768 ? 60 : 80;
  }

  public getCompletedPages(){
    this.asyncCall(() => this.registryService.getRegistryCompletedPages(), response => {
      this.registryCompletedPages = response.Item || new AnagraficaUtentePortalePagineCompilate();
      let total = 0;
      if(this.registryCompletedPages.PaginaAnagrafica)
        total += 1;
      if(this.registryCompletedPages.PaginaIstruzione)
        total += 1;
      if(this.registryCompletedPages.PaginaPreferenze)
        total += 1;
      if(this.registryCompletedPages.PaginaLavoro)
        total += 1;
      /*if(this.registryCompletedPages.PaginaDocumenti)
        total += 1;*/
      if(total == 0){
        this.percCompleted = 1;
        this.showValueBar = false;
      }
      else
        this.percCompleted = total / 4 * 100;
    });
  }

  public goToAnagrafica(){
    this.navigate(['/registry']);
  }
  public goToLavoro(){
    this.navigate(['/work']);
  }
  public goToIstruzione(){
    this.navigate(['/study']);
  }
  public goToPreferenze(){
    this.navigate(['/preferences']);
  }

}
